import baseURL, { config } from "../Api/baseURL";
import { useNavigate } from "react-router-dom";

// Helper function to get token from localStorage


export const useGetData = async (url, params, navigate) => {
  const loggedUser=JSON.parse(localStorage.getItem('user')); 
  let token
if(loggedUser?.token) {
  token = loggedUser?.token
}

  const tokenConfig = {
    ...config,
    headers: {
      ...(token
      ? { Authorization: `Bearer ${token}` }
      : { is_admin: true }),  
    },
    params: params,
  };

  const res = await baseURL.get(url, tokenConfig);
  console.log("res.data", res.data);

  return res.data;
};

export const useGetDataToken = async (url, params) => {
  // Clone the existing config and add the token
  const tokenConfig = {
    ...config,
    headers: {
      ...config.headers,
      // reservation_token: getToken(), 
    },
  };

  const res = await baseURL.get(url, tokenConfig);
  console.log("res.data",res.data);
  return res.data;
};
